/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_SearchInputs */

const es_tools_legajox_search = /** @type {(inputs: Tools_Legajox_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscando documentos en Legajox...`)
};

const en_tools_legajox_search = /** @type {(inputs: Tools_Legajox_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searching documents in Legajox...`)
};

/**
* | output |
* | --- |
* | "Searching documents in Legajox..." |
*
* @param {Tools_Legajox_SearchInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_search = /** @type {((inputs?: Tools_Legajox_SearchInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_SearchInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_search(inputs)
	return en_tools_legajox_search(inputs)
});
export { tools_legajox_search as "tools.legajox.search" }